import React from "react";
import styles from "./styles.module.css";

import { useEffect, useState } from "react";

export enum VERIFIEDSIZE {
  SMALL = "SMALL",
  LARGE = "LARGE",
}
interface Props {
  nationalIdVerified?: boolean;
  size?: VERIFIEDSIZE;
}

const UserIdVerifiedIcon = ({ nationalIdVerified, size }: Props) => {
  const [nationalIdVerifiedState, setNationalIdVerified] = useState<boolean>();
  useEffect(() => {
    setNationalIdVerified(nationalIdVerified);
  }, [nationalIdVerified]);
  return (
    <>
      {nationalIdVerifiedState ? (
        <img
          className={
            size === VERIFIEDSIZE["SMALL"]
              ? styles.verifiedIconSmall
              : styles.verifiedIcon
          }
          src={"/assets/images/svg/verifiedIcon.svg"}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default UserIdVerifiedIcon;
